import { Billing } from '@/data/types';
import type { Extinguisher } from '@/data/types';

// A disposed extinguisher stays in the customer's array on purpose: replacing a
// unit marks the old one Billing.DISPOSED and keeps it as a service record
// (client #54). It is no longer equipment on site though, so it must not appear
// in any "how many devices does this customer have" number (client #77).
// Invoicing is the deliberate exception — disposal is a billable line, see
// lib/billing.ts.
// Hoses are counted in one bucket rather than per device type; this key has no
// device_type doc behind it, so callers must label it themselves.
export const HOSE_COUNT_KEY = 'loeschposten';

export const isOnSite = (e: Extinguisher): boolean =>
  e.billing !== Billing.DISPOSED;

/** Extinguishers still physically on site (disposed units excluded). */
export const onSiteExtinguishers = (list: Extinguisher[]): Extinguisher[] =>
  list.filter(isOnSite);
